import { cn } from "@/lib/utils";
import { fmtPct, TONE_BG, TONE_TEXT, trsTone } from "@/lib/format";

export const TrsBar = ({ label, value, testId }) => {
  const t = trsTone(value);
  return (
    <div className="flex items-center gap-2 text-[11px]" data-testid={testId}>
      <span className="w-5 text-muted-foreground font-mono">{label}</span>
      <div className="flex-1 h-1.5 bg-muted rounded-sm overflow-hidden">
        <div className={cn("h-full transition-[width] duration-500", TONE_BG[t])} style={{ width: `${Math.min(value || 0, 100)}%` }} />
      </div>
      <span className={cn("w-14 text-right font-mono", TONE_TEXT[t])}>{fmtPct(value)}</span>
    </div>
  );
};
